import messages from "../../../locale/jsonMessages";
import { emailSubjectLimit } from "../../../helpers/fieldRestriction";
const validate = (values) => {
    const errors = {}
    if (!values.subject) {
        errors.subject = messages.required;
    } else if (values.subject.length > emailSubjectLimit) {
        errors.subject = messages.pushNotificationTemplateValidationMessageMaxLength;
    }
    if (!values.previewText) {
        errors.previewText = messages.required;
    } else if (values.previewText.length > emailSubjectLimit) {
        errors.previewText = messages.pushNotificationTemplateValidationMessageMaxLength;
    }
    if (!values.bodyHtml || values.bodyHtml === "<h1> </h1>" || values.bodyHtml === "<h2> </h2>" || values.bodyHtml === "<h3> </h3>" || values.bodyHtml === "<h4> </h4>" || values.bodyHtml === "<p> </p>") {
        errors.bodyHtml = messages.required;
    }

    return errors;

}

export default validate